var index = require('../Content/css/index.less'),
	banner = require('../Content/js/banner.js');
//define('index',function(){
//	$("#weixin").on('tap',function(){
//		$("#airwheel_weixin").show();
//		$("#airwheel_weixin .weixin").addClass("prompt_show");
//	});
//});
//define(['index'],function(index){})
//$(function() {
//	$("#weixin").on('tap', function() {
//		$("#airwheel_weixin").show();
//		$("#airwheel_weixin .weixin").addClass("prompt_show");
//	});
//	$("#airwheel_weixin").on('tap', function() {
//		$("#airwheel_weixin").hide();
//		$("#airwheel_weixin .weixin").removeClass("prompt_show");
//	});
//})


// WEBPACK FOOTER //
// ./E:/airwheel.net_mob/entry/index.js